// Board view filters: day chips, This Week / Resolved tabs, Mine toggle. Plain
// signals — deriving the visible cards happens in the Board component.
import { signal } from '@preact/signals';

export const dayFilter = signal<string>('all');
export const viewMode = signal<'week' | 'resolved'>('week');
export const mineOnly = signal<boolean>(false);
